import { SortItemDto } from "./SortItem";
import { PageDto } from "./Page";
import { Expr } from "./expr/Expr";
import { andExpr } from "./expr/constraints/logical/AndXpr";

export interface QueryDto {
  page?: PageDto;
  sort?: Array<SortItemDto>;
  where?: Expr;
}

export type QueryWithoutPageDto = Omit<QueryDto, "page">;

export class Query {
  readonly page?: PageDto;
  readonly sort?: Array<SortItemDto>;
  readonly where?: Expr;

  constructor(args: {
    page?: PageDto;
    sort?: Array<SortItemDto> | null;
    where?: Expr;
  }) {
    this.page = args.page;
    this.sort = args.sort ?? undefined;
    this.where = args.where;
  }

  andWhere(where: Expr): Query {
    return new Query({
      page: this.page,
      sort: this.sort,
      where: this.where != null ? andExpr(this.where, where) : where,
    });
  }

  toDto(page?: PageDto): QueryDto {
    return {
      page: page != null ? page : this.page,
      sort: this.sort,
      where: this.where,
    };
  }

  withSort(sort: SortItemDto[]) {
    return new Query({
      page: this.page,
      sort: sort,
      where: this.where,
    });
  }
}
